<template>
  <div class="alert" :class="[state, size, layout]">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    state: {
      type: String as PropType<
        "default" | "error" | "info" | "warning" | "success"
      >,
      default: "default",
    },
    size: {
      type: String as PropType<"small" | "medium">,
      default: "medium",
    },
    layout: {
      type: String as PropType<"horizontal" | "vertical" | "center">,
      default: "horizontal",
    },
  },
});
</script>

<style lang="scss" scoped>
.alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
  padding: 16px 24px 16px 24px;
  border-radius: $border-radius-l;
  margin-bottom: 12px;
  @extend %font-body-regular;
  @include themed() {
    background-color: t($tertiary-10);
    color: t($tertiary-100);
  }

  &.small {
    padding: 12px;
    width: 100%;
    @extend %font-caption-regular;
  }

  &.info {
    @include themed() {
      color: t($grey-60);
      background: t($grey-05);
    }
  }

  &.error {
    @include themed() {
      background-color: rgba(t($secondary-10), 0.5);
      color: t($primary);
    }
  }

  &.warning {
    background-color: $calendar-b-20;
    color: $calendar-b-80;
  }

  &.success {
    background-color: $calendar-e-20;
    color: $calendar-e-80;
  }

  :deep(p:first-child) {
    margin-top: 8px;
  }

  :deep(p) {
    margin-bottom: 8px;
  }

  :deep(.base-button) {
    flex-shrink: 0;
  }

  &.vertical {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &.center {
    justify-content: center;
    padding: 24px;
  }
}
</style>
